import { useCallback } from 'react';
import {
	fireOperationalAnalyticsDeferred,
	useAnalyticsEvents,
	type UIAnalyticsEvent,
} from '@atlassian/jira-product-analytics-bridge';

const MODAL_LOAD_TASK_NAME = 'viewGlobalIssueCreateModal';

const MODAL_LOAD_TASK_FAIL_EVENT_NAME = 'ui taskFail';
const MODAL_LOAD_TASK_SUCCESS_EVENT_NAME = 'ui taskSuccess';

export const useModalLoadUiTaskEvents = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireModalLoadTaskFailEvent = useCallback(() => {
		const analyticsEvent = createAnalyticsEvent({});
		fireOperationalAnalyticsDeferred(analyticsEvent, MODAL_LOAD_TASK_FAIL_EVENT_NAME, {
			task: MODAL_LOAD_TASK_NAME,
		});
	}, [createAnalyticsEvent]);

	const fireModalLoadTaskSuccessEvent = useCallback((analyticsEvent: UIAnalyticsEvent) => {
		fireOperationalAnalyticsDeferred(analyticsEvent, MODAL_LOAD_TASK_SUCCESS_EVENT_NAME, {
			task: MODAL_LOAD_TASK_NAME,
		});
	}, []);

	return { fireModalLoadTaskFailEvent, fireModalLoadTaskSuccessEvent };
};
